import { Component, OnInit, SimpleChange } from '@angular/core';
import { DataManipService } from 'src/app/services/data-sharing.service';

@Component({
    selector: 'app-default-sidebar',
    templateUrl: './default-sidebar.component.html',
    styleUrls: ['./default-sidebar.component.scss'],
    standalone: false
})
export class DefaultSidebarComponent implements OnInit {

  tempvariable: boolean = false;
  userRole: string = '';

  // Which second-level sub-group (Transactions > Purchase/Karagir/Sales/Labelling, Masters >
  // Manage Schemes and Members, Utility > User Maintanance) is currently drilled into. Kept
  // as one flag rather than one per parent since only one top-level group is ever open at a
  // time anyway (see group-1..5's shared "nav-main-group" radio name in the template) — so
  // there's never a case where two different parents' sub-groups could collide.
  // While one is set, its parent list hides every OTHER item at that level (siblings and
  // other sub-groups alike), leaving only this sub-group and its own children visible —
  // toggling the same one again (or switching top-level group, which resets this to null)
  // brings everything back.
  openSubGroup: string | null = null;

  toggleSubGroup(name: string) {
    this.openSubGroup = this.openSubGroup === name ? null : name;
    this.openSubSubGroup = null;
  }

  // Third-level drill-down within a second-level sub-group. Separate flag from openSubGroup so a
  // sub-group can hold more than one third-level entry.
  openSubSubGroup: string | null = null;

  toggleSubSubGroup(name: string) {
    this.openSubSubGroup = this.openSubSubGroup === name ? null : name;
  }

  constructor(public dataManipSrvc: DataManipService) { }

  // Gates the whole "Super Admin Controls" group — same permission the purchase screen's
  // posting-mapping mode itself checks (backend re-checks it on every call regardless, this
  // only hides the menu entry).
  get canAccessSuperAdminControls(): boolean {
    const perms = this.dataManipSrvc.loginData?.userPermissions;
    return Array.isArray(perms) && perms.includes('utility.posting_mapping.modify');
  }
  ngOnInit(): void {

  }

  
  ngOnChanges(changes:SimpleChange){
    console.log(changes);
    
  }

  // togglemini() {
  //   document.body.classList.toggle('sidebar-mini');
  // }

  // Bound to every nav-link/nav-sub-link's (click) so the sidebar auto-closes after picking
  // an item on mobile, where it's an off-canvas overlay. `sidebar-lg-show` is also what keeps
  // the sidebar visible at all on desktop (index.html sets it on <body> by default; see
  // _sidebar-nav.scss's `&.sidebar-lg-show .nav-side-menu { margin-left: 0 }` under the
  // >=992px media query) — toggling it unconditionally here removed it on the very first
  // navigation click on desktop too, hiding the sidebar for the rest of the session (it's a
  // plain DOM class, so browser back doesn't restore it either). 991.98px matches this
  // stylesheet's own existing mobile/desktop breakpoint.
  togglemini() {
    if (window.innerWidth >= 992) return;
    document.body.classList.toggle('sidebar-lg-show');
    window.dispatchEvent(new Event('resize'));
  }

  toggle() {
    document.body.classList.toggle('sidebar-mini');
    window.dispatchEvent(new Event('resize'));
  }


  // top: any;
  // getPositionOfcursor(e: any) {
  //   this.top = e.offsetY
  //   console.log(this.top);
    

  // }

}
